import { useEffect, useState } from "react";
import Api from "../../../../services/Api";
import Functions from "../../../../services/Functions";
import BigCard from "../../../general/BigCard";
import PieGraph from "../../../general/PieGraph";
import Leaflet from "./maps/LeafletMap";
import styles from "./SocialL2.module.css";
import { SocialStore } from "./SocialStore";

function SocialL2({ distrito }) {
  const [numeroPropriedades, setNumeroPropriedades] = useState(null);
  const [areaMedia, setAreaMedia] = useState(null);
  const [rendaPrincipal, setRendaPrincipal] = useState(null);
  const [dificuldade, setDificuldade] = useState(null);
  const [rendaPrincipalOldValue, setRendaPrincipalOldValue] = useState(null);
  const [dificuldadeOldValue, setDificuldadeOldValue] = useState(null);

  const rendaExclusivaValue = SocialStore((state) => state.rendaExclusivaValue);

  const creditoRuralValue = SocialStore((state) => state.creditoRuralValue);

  const possuiEmpresaValue = SocialStore((state) => state.possuiEmpresaValue);

  const rendaPrincipalValue = SocialStore((state) => state.rendaPrincipalValue);

  const dificuldadeValue = SocialStore((state) => state.dificuldadeValue);

  const empreendedorismoValue = SocialStore(
    (state) => state.empreendedorismoValue,
  );

  const recebeRecursosValue = SocialStore((state) => state.recebeRecursosValue);

  const atividadeRuralValue = SocialStore((state) => state.atividadeRuralValue);

  const setRendaPrincipalValue = SocialStore(
    (state) => state.setRendaPrincipalValue,
  );

  const setDificuldadeValue = SocialStore((state) => state.setDificuldadeValue);

  const setRendaPrincipalImage = SocialStore(
    (state) => state.setRendaPrincipalImage,
  );

  const setDificuldadeImage = SocialStore((state) => state.setDificuldadeImage);

  const setSocialMapImage = SocialStore((state) => state.setSocialMapImage);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [numeroPropriedades, areaMedia, rendaPrincipal, dificuldade] =
          await Promise.all([
            Api.getNumeroPropriedadesSocial(
              distrito,
              rendaExclusivaValue,
              creditoRuralValue,
              possuiEmpresaValue,
              rendaPrincipalValue,
              dificuldadeValue,
              empreendedorismoValue,
              recebeRecursosValue,
              atividadeRuralValue,
            ),
            Api.getAreaMediaSocial(
              distrito,
              rendaExclusivaValue,
              creditoRuralValue,
              possuiEmpresaValue,
              rendaPrincipalValue,
              dificuldadeValue,
              empreendedorismoValue,
              recebeRecursosValue,
              atividadeRuralValue,
            ),
            Api.getRendaPrincipalRural(
              distrito,
              rendaExclusivaValue,
              creditoRuralValue,
              possuiEmpresaValue,
              null,
              dificuldadeValue,
              empreendedorismoValue,
              recebeRecursosValue,
              atividadeRuralValue,
            ),
            Api.getMaiorDificuldade(
              distrito,
              rendaExclusivaValue,
              creditoRuralValue,
              possuiEmpresaValue,
              rendaPrincipalValue,
              null,
              empreendedorismoValue,
              recebeRecursosValue,
              atividadeRuralValue,
            ),
          ]);
        setNumeroPropriedades(numeroPropriedades);
        setAreaMedia(areaMedia);
        setRendaPrincipal(Functions.buildSmallPieGraphParams(rendaPrincipal));
        setDificuldade(Functions.buildPieGraphParams2(dificuldade));
      } catch (error) {
        console.error("Erro ao buscar dados:", error);
      }
    };
    fetchData();
  }, [
    distrito,
    rendaExclusivaValue,
    creditoRuralValue,
    possuiEmpresaValue,
    rendaPrincipalValue,
    dificuldadeValue,
    empreendedorismoValue,
    recebeRecursosValue,
    atividadeRuralValue,
  ]);

  const onRendaPrincipalClick = (value) => {
    setRendaPrincipalValue(value);
  };

  const onDificuldadeClick = (value) => {
    setDificuldadeValue(value);
  };

  return (
    <div className={styles.socialL2}>
      <div className={styles.cards}>
        <div className={styles.bigCard}>
          <BigCard name="Propriedades" value={numeroPropriedades?.value} />
        </div>
        <div className={styles.card}>
          <BigCard
            name={
              <>
                Área Média
                <br />
                (ha)
              </>
            }
            value={areaMedia?.value?.toFixed(2)}
          />
        </div>
      </div>

      <div className={styles.map}>
        <Leaflet distrito={distrito} onImageReady={setSocialMapImage} />
      </div>

      <div className={styles.barGraph}>
        <div className={styles.pieGraph}>
          {rendaPrincipal && (
            <PieGraph
              data={rendaPrincipal}
              text="RENDA PRINCIPAL"
              onLegendClick={onRendaPrincipalClick}
              currentValue={rendaPrincipalValue}
              oldValue={rendaPrincipalOldValue}
              onOldValue={setRendaPrincipalOldValue}
              onImageReady={setRendaPrincipalImage}
            />
          )}
        </div>
        <div className={styles.pieGraph}>
          {dificuldade && (
            <PieGraph
              data={dificuldade}
              text="DIFICULDADE"
              onLegendClick={onDificuldadeClick}
              currentValue={dificuldadeValue}
              oldValue={dificuldadeOldValue}
              onOldValue={setDificuldadeOldValue}
              onImageReady={setDificuldadeImage}
            />
          )}
        </div>
      </div>
    </div>
  );
}

export default SocialL2;
